
var $body,
    $shareButton,
    $menuToggle,
    $header;

var $stickyFooter,
    $stickyAnchor,
    $stickyClose;

var $termToggle,
    $terms;

var $jobFormToggle,
    $jobForm;

var $gvUpload;

var $steps;

var $slides,
    $videoSlides;

var $stickyHeader,
    $stickyHeaderAnchor;

var $scrollToForm;

var $stickySidebar,
    $sidebarBottom;

var $imageClickItem;

var $playVideo,
    $playVideoPopup,
    $videoPopup,
    $closeVideoPopup;

var $tabToggle;

var $gutenbergBlockBtn;

var $historyBackBtns;

var $productsColumn;

var $submenu;

$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    /* -----------------------------------
     | Get elements
     * ----------------------------------- */
    $body = $('body');
    $shareButton         = $('.js-share');
    $menuToggle          = $('.js-toggle-menu');
    $header              = $('.js-site-header');
    $stickyFooter        = $('.js-sticky-footer');
    $stickyAnchor        = $('.js-toggle-sticky');
    $stickyClose         = $('.js-close-sticky');
    $termToggle          = $('.js-term-toggle');
    $terms               = $('.js-terms');
    $jobForm             = $('.js-job-newsletter');
    $jobFormToggle       = $('.js-toggle-job-newsletter');
    $gvUpload            = $('.ginput_container_fileupload input[type=file]');
    $gvUploadButton      = $('.ginput_container_fileupload + .gfield_description');
    $historyBackBtns     = $('.js-add-history-back');
    $steps               = $('.js-step');
    $slides              = $('.js-infinite-slider');
    $videoSlides         = $('.js-video-slider');
    $stickyHeader        = $('.js-sticky-header');
    $stickyHeaderAnchor  = $('.js-main-start');
    $scrollToForm        = $('.js-scroll-to-form');
    $stickySidebar       = $('.js-sticky-sidebar');
    $sidebarBottom       = $('.js-sticky-sidebar-bottom');
    $imageClickItem      = $('.js-image-click-item');
    $playVideo           = $('.js-video-play');
    $playVideoPopup      = $('.js-open-video-popup');
    $videoPopup          = $('.js-video-popup');
    $closeVideoPopup     = $('.js-close-popup');
    $tabToggle           = $('.js-tab-toggle');
    $gutenbergBlockBtn   = $('.wp-block-button__link');
    $productsColumn      = $('.js-products-column');
    $submenu             = $('.js-toggle-submenu');


    /* -----------------------------------
     | Startup functions
     * ----------------------------------- */
    toggleStickyFooter();
    toggleStickyHeader();
    stickySidebarResize();
    stickySidebar();
    updateGutenbergBlocKBtns();
    addHistoryBack();
    addProductsColumn($('.b-products__columns.is-open'));

    /* -----------------------------------
     | Event listeners
     * ----------------------------------- */

    // Gloval click event
    $(window).click(function() {
        $shareButton.removeClass('is-open'); // Close the share button dropdown
    });

    $submenu.on('click', function() {
        if ($(this).hasClass('is-open')) {
            // Close this submenu
            $(this).removeClass('is-open');
            $(this).next().slideUp();
        } else {
            $submenu.next().slideUp();
            $submenu.removeClass('is-open');

            $(this).addClass('is-open');
            $(this).next().slideDown();
        }
    });

    // Open the share button dropdown
    $shareButton.click(function() {
        event.stopPropagation(); // To prevent double click action (the window click event)
        $(this).toggleClass('is-open');
    });

    // Toggle for the mobile menu and hamburger
    $menuToggle.click(function() {
        $header.toggleClass('has-open-menu');
    });

    // Close sticky footer
    $stickyClose.click(function() {
        $stickyFooter.addClass('is-closed');
    });

    $tabToggle.click(function(){
       if($(this).hasClass('is-open')) {
           return false;
       }

       var targetIndex = $(this).data('index');
       var $target = $('.js-tab[data-index=' + targetIndex + ']');

        $tabToggle.removeClass('is-open');
       $('.js-tab').removeClass('is-open');
       $(this).addClass('is-open');
       $target.addClass('is-open');
       addProductsColumn($target);

    });

    $termToggle.click(function (e) {
        e.preventDefault();
        var slug = $(this).data('slug');
        var $target = $('.js-term-' + slug);

        $termToggle.addClass('c-button--ghost-primary');
        $(this).removeClass('c-button--ghost-primary');

        if (slug === 'all') {
            $terms.slideDown();
        } else {
            $terms.not($target).slideUp();
            $target.slideDown();
        }
    });

    $jobFormToggle.click(function() {
        $jobForm.slideDown();
        $jobForm[0].scrollIntoView({ block: 'start',  behavior: 'smooth' });
        $jobForm.find('input').focus();
    });

    $scrollToForm.click(function() {
        $('.b-form')[0].scrollIntoView({ block: 'center',  behavior: 'smooth', offsetTop: -500 });
    });


    $steps.on('click', function(){
        $(this).toggleClass('is-open');
        if ($(this).hasClass('is-open')) {
            $(this).next().slideDown();
        } else {
            $(this).next().slideUp();
        }

    });

    $slides.owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplayTimeout': 5000,
        'autoplaySpeed': 5000,
        'slideTransition': 'linear',
        'responsive' : {
            0 : {
                items: 1
            },
            // 576 : {
            //     items: 1
            // },
            768 : {
                items: 2
            },
            // 992 : {
            //     items: 2
            // },
            1212 : {
                items: 3
            },
            2000 : {
                items: 4
            }
        }
    });

    $('.js-infinite-slider-reviews').owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplayTimeout': 5000,
        'autoplaySpeed': 5000,
        'slideTransition': 'linear',
        'responsive' : {
            0 : {
                items: 1
            },
            576 : {
                items: 2
            },
            // 768 : {
            //     items: 2
            // },
            992 : {
                items: 3
            },
            1500 : {
                items: 4
            },
            2000 : {
                items: 5
            }
        }
    });

    $videoSlides.owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplaySpeed': 1000,
        'items' : 1,
        'dots': true
    });

    $imageClickItem.click(function(){
        var groupId = $(this).parent().data('id');

        $groupItems = $('.js-image-click-item__parent[data-id="'+groupId+'"]');

        $groupItems.removeClass('is-active');
        $(this).parent().addClass('is-active');
    });

    $playVideo.click(function() {

        $target = $(this).parent().prev();

        var $targetContainer = $target.find('.js-video');
        var firstLoad = ! $targetContainer.data('iframeLoaded');

        if(firstLoad) {
            var iframeHtml = $targetContainer.data('iframeHtml');
            $iframe = $(iframeHtml);
            var autoplaySrc = $iframe[0].src + '&autoplay=1';
            $iframe.attr('src', autoplaySrc);

            $iframe.appendTo($targetContainer);
            $targetContainer.data('iframeLoaded', true);
        }

        if ($target.hasClass('is-active')) {
            $target.removeClass('is-active');
            $videoSlides.trigger('play.owl.autoplay');
        } else {
            $target.addClass('is-active');
            $videoSlides.trigger('stop.owl.autoplay');
        }
    });

    // Upload field for gravityform
    $gvUpload.on('change',function() {
        if (this.files[0].name) {
            $(this).parent().next().attr('data-filename',this.files[0].name);
        }
    });

    $gvUploadButton.on('click', function () {
        $gvUpload.trigger('click');
    });

    $playVideoPopup.on('click', function () {
        $videoPopup.addClass('is-open');
        var $iframe = $videoPopup.find('iframe');

        $iframe[0].src += "&autoplay=1";
    });

    $closeVideoPopup.on('click', function () {
        $videoPopup.removeClass('is-open');
        var $iframe = $videoPopup.find('iframe');
        var src = $iframe[0].src;
        src = src.replace("&autoplay=1", "");
        $iframe[0].src = src;
    });


    // Scroll event
    $(window).scroll(function() {
        toggleStickyFooter();
        toggleStickyHeader();
        stickySidebar();
    });

    $( window ).resize(function() {
        stickySidebarResize();
    });
});


/* ------------*
 |  Functions  |
 * ------------*/

function toggleStickyFooter() {
    if ($stickyFooter.length > 0) {
        var screenHeight = $(window).height();
        var anchorOffset = $stickyAnchor.offset().top;
        var scroll = $(window).scrollTop();
        var togglePosition = scroll + screenHeight;
        var check = (anchorOffset > togglePosition);

        if (check) {
            $stickyFooter.addClass('is-visible');
        } else {
            $stickyFooter.removeClass('is-visible');
        }
    }
}

function toggleStickyHeader() {
    if ($stickyHeader.length > 0) {
        var anchorOffset = $stickyHeaderAnchor.offset().top;
        var scroll = $(window).scrollTop();
        var check = (scroll > anchorOffset);

        if (check) {
            $stickyHeader.addClass('is-visible');
        } else {
            $stickyHeader.removeClass('is-visible');
        }
    }
}

function stickySidebarResize() {
    if ($sidebarBottom.length >= 1) {
        var maxOffset = $sidebarBottom.offset().top + $sidebarBottom.height();
        var $parentContainer = $stickySidebar.parent();
        var parentOffset = $parentContainer.offset().top + $parentContainer.height();
        var offset = maxOffset - parentOffset;

        $parentContainer.css('bottom', -offset);
    }
}

function stickySidebar() {
    if ($sidebarBottom.length >= 1) {
        var maxOffset = $sidebarBottom.offset().top + $sidebarBottom.height();
        var topOffset = $(window).scrollTop() + 104 + 48;

        if (maxOffset < topOffset + $stickySidebar.height()) {
            $stickySidebar.addClass('is-stuck-bottom');
        } else {
            $stickySidebar.removeClass('is-stuck-bottom');
        }
    }
}

function updateGutenbergBlocKBtns() {
    $gutenbergBlockBtn.addClass('c-button');
}

function addHistoryBack() {
    $historyBackBtns.click(function() {
        history.back();
    });
}

function addProductsColumn($openTab) {
    $productsColumn.removeAttr('class').addClass('js-products-column col-12 col-lg-' + (3 + $openTab.children().length * 3));
}
